'use strict';

var svaneTvis = svaneTvis || {};
var novicell = novicell || {};
var markers = markers || [];
var shopList = shopList || [];

svaneTvis.map = svaneTvis.map || new function () {
    let isTvis = document.querySelector('.js-is-tvis');
    
    let icon = '/frontend/dist/images/tvis_google_pin.png';
    let IconWidth = 34;
    let IconHeight = 50; 

    if(!isTvis) {
        icon = "/frontend/dist/images/svane_google_pin.png";
        IconWidth = 30;
        IconHeight = 45; 
    }

    this.init = function () {
        novicell.map.init({
            apiKey: 'AIzaSyCKw7im4u7h50OPS4KM5hCC3us-gnlbbTE',
            selector: '#map-canvas',
            icon: {
                url: icon,
                size: {
                    width: IconWidth,
                    height: IconHeight
                }
            },
            
            infoWindow: '',
            mapOptions: {
                disableDefaultUI: false,
                draggable: true,
                scrollwheel: false,
                styles: [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#aeaeae"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}]

            },
            markers: shopList
        });
    };
}();